export const getScenarioSocketUrl = (namespace: string) => {
  const baseUrl = process.env.REACT_APP_WEBSOCKET_URL || '';
  const normalizedBase = baseUrl.replace(/\/api\/?$/, '');
  const normalizedNamespace = namespace.replace(/^\/+/, '');

  return `${normalizedBase}/${normalizedNamespace}`;
};
